/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для табов размеров в карточке товара
   */
  app.ModifiersView = app.View.extend({
    el: '#product-tabs',
    // Обработчики пользовательских событий
    events: {
      'click .tab': 'toggleModifier',
      'change .js-modifier-select': 'toggleModifier',
      'click .modifiers-more': 'toggleMoreModifier',
      'click .js-show-pic-modifiers': 'showPicModifiers',
      'mousedown select': app.helpers.DomHelper.preventInputZoom,
    },
    modifierScroll: 0,
    currentTab: null,
    // Количество модификаторов, помещающихся в один ряд вместе с кнопкой 'ещё'
    modifiersRowCount: null,
    // Общее количество модификаторов у товара
    countOfModifiers: null,
    // Количество скрытых модификаторов
    countOfHideModifiers: null,
    // Ширина модификатора
    modifierWidth: 60,
    additionalOptions: [
      'isModifiersOpened',
      'categoryCollection',
      'noWrap',
      'mainWindow',
      'isCatalog',
      'currency',
    ],
    run: function () {
      this.collection.forEach(function (model) {
        model.isSync = false;
        if (!model.get('cart_item')) {
          model.set('cart_item', {
            qty: ''
          });
        } else {
          if (_.isUndefined(model.get('cart_item').qty)) {
            model.set('cart_item', JSON.parse(decodeURIComponent(model.get('cart_item'))));
          }
        }
      });
      var $currentModifier = this.$('[data-modifier=' + this.model.get('id') + ']');
      if ($currentModifier.length) {
        $currentModifier.click();
      }
      if (!this.noWrap) {
        this.wrapModifiers();
      }
      this.updateModifiers(this.model, this.model.get('cart_item'));
      this.listenTo(Backbone, 'updated-modifier-count', this.updateModifiers);
      if (this.isCatalog) {
        this.listenTo(this.mainWindow, 'window.resize', this.changeModifiersRowCount);
      }
    },

    /**
     * Обновляет кол-во добавленных в корзину размеров.
     */
    updateModifiers: function (model, cartItem) {
      var item = this.collection.findWhere({
          id: model.get('id')
        }),
        that = this,
        modifier,
        isPicture = model.get('modifier') && model.get('modifier').is_picture,
        id;
      if (item) {
        if (cartItem) {
          if (cartItem.item) {
            item.set('retail_fee_markup', cartItem.item.get('retail_fee_markup'));
          }
          item.set('cart_item', cartItem);
        } else {
          item.set('cart_item', {
            qty: ''
          });
          item.set('retail_fee_markup', null);
        }
        this.$('.tab').each(function (index, modifierElement) {
          var $modifierElement = $(modifierElement);
          id = $modifierElement.data('modifier');
          modifier = that.collection.get(id);
          var qtyBlock = $modifierElement.find('b');
          if (modifier && modifier.get('cart_item') && _.isNumber(modifier.get('cart_item').qty)) {
            var value = ' (' + modifier.get('cart_item').qty + ')';
            if (isPicture && (!app.isMobile || that.user.get('isMobileAnalog'))) {
              qtyBlock.addClass('in-cart-modifier');
              value = value.replace(/[(,) ]/g, '');
            }
            qtyBlock.text(value);
          } else {
            if (isPicture && !app.isMobile) {
              qtyBlock.removeClass('in-cart-modifier');
            }
            qtyBlock.text('');
          }
        });
      }
    },

    /**
     * Обрабатывает клик на размер товара.
     * Выбирается модель, передается во вьюху, отвечающую за цену и блок "в корзину".
     * Вьюха себя перерисовывает.
     */
    toggleModifier: function (e) {
      e.preventDefault();
      this.currentTab = (e.currentTarget.localName === 'select'
      ? this.$(e.currentTarget.selectedOptions[0])
      : $(e.target).closest('.tab'));

      var modifierId = this.currentTab.data('modifier'),
        model = this.collection.get(modifierId);
      if (this.model.isSync || this.currentTab.hasClass('selected')) {
        return;
      }
      if (!model.get('sid')) {
        model.urlRoot = '/api/v3/item/';
        model.expand = 'expand=delivery_info,photo_sizes,badges,retail_fee_markup,special_offer_badge_label';
        model.requestParameters = {
          currency: this.currency.name,
        };
        this.listenToOnce(model, 'sync', this.updateModifierModel);
        model.fetch();
      } else {
        this.updateModifierModel(model);
      }
    },

    /**
     * Обновляем модель модификаторов.
     * @param {Item} model Модель модификатора.
     * @param {Object} resp Ответ с сервера.
     */
    updateModifierModel: function (model, resp) {
      this.collection.each(function (modifier) {
        modifier.set('selected', false);
      });
      model.set({
        selected: true,
        badges: (resp && resp.badges.length)
          ? app.Item.prototype.getBadges(model.get('badges'), resp._meta.badges)
          : model.get('badges'),
      });
      this.model = model;
      this.modifierScroll = this.$('.tabs').scrollTop();
      app.helpers.OkoHelper.push({
        'n': 'tab-choice',
        'sid': model.get('sid')
      });

      this.$('option')
        .removeClass('selected');
      this.$('.tab')
        .removeClass('selected')
        .find('span')
        .addClass('link link_dark link_pseudo');
      this.$('.color-icon')
        .removeClass('color-icon_selected');

      this.currentTab
        .addClass('selected')
        .find('.link')
        .removeClass('link link_dark link_pseudo');
      this.currentTab
        .find('.color-icon')
        .addClass('color-icon_selected');

      this.trigger('modifier-click', model);
      Backbone.trigger('modifier-click', model);
    },
    /**
     * Сворачивает модификаторы если необходимо.
     */
    wrapModifiers: function () {
      var modifier = this.model.get('modifier');
      if ((this.categoryCollection && this.isCatalog) || (modifier && modifier.is_picture)) {
        var modifierAction;
        if (this.isModifiersOpened) {
          modifierAction = this._openModifiers.bind(this);
        } else {
          modifierAction = this._closeModifiers.bind(this);
        }
        setTimeout(modifierAction, 0);
      }
    },

    /**
     * Отображение размеров(модификаторов) в списке товаров
     */
    toggleMoreModifier: function () {
      var $container = this.$('.tabs');
      if ($container.hasClass('modifiers-hidden')) {
        this.trigger('toggle-more-modifier', true);
        this._openModifiers();
      } else {
        this.trigger('toggle-more-modifier', false);
        this._closeModifiers();
      }
    },

    /**
     * Открытие модификаторов
     * @private
     */
    _openModifiers: function () {
      if (!app.isMobile) {
        this.$('.tabs')
          .addClass('modifiers-opened')
          .scrollTop(this.modifierScroll)
          .removeClass('modifiers-hidden');
        this.$('.modifiers-more').text('Скрыть');
        this.$('.modifiers-more_wrapper').removeClass('not_display');
      }
    },

    /**
     * Закрытие модификаторов
     * @private
     */
    _closeModifiers: function () {
      this.$('.hidden-on-init').removeClass('hidden-on-init');
      if (!app.isMobile) {
        var $container = this.$('.tabs');
        this.modifierScroll = $container.scrollTop();
        $container.removeClass('modifiers-opened').addClass('modifiers-hidden').scrollTop(0.0);
        if ($container.length) {
          this.$('.modifiers-more_wrapper').addClass('not_display');
          this.$('.js-show-pic-modifiers').removeClass('not_display');
          this.changeModifiersRowCount();
        }
      }
    },
    /**
     * Показывает скрытые модификаторы с картинками.
     * @param {Object} e
     */
    showPicModifiers: function (e) {
      this.$(e.currentTarget).addClass('not_display');
      this.$('.tab.modifier-pic').removeClass('not_display');
      this.toggleMoreModifier();
    },

    /**
     * Изменяет количество модификаторов, помещающихся в один ряд
     */
    changeModifiersRowCount: function () {
      var modifier = this.model.get('modifier');
      if (!app.isMobile && modifier && modifier.is_picture && this.$('.tabs').length) {
        var modifiersBlockWidth = $('.catalog-tabs').width(),
          newModifiersRowCount = parseInt(modifiersBlockWidth / this.modifierWidth, 10) - 1;
        if (this.modifiersRowCount !== newModifiersRowCount || !this.countOfModifiers || !this.countOfHideModifiers) {
          this.modifiersRowCount = newModifiersRowCount;
          this.countOfModifiers = this.$('.tab').length;
          this.countOfHideModifiers = this.countOfModifiers - this.modifiersRowCount;
        }
        if (!this.isModifiersOpened) {
          this.updateCountModifiers(this.modifiersRowCount, this.countOfHideModifiers);
        }
      }
    },

    /**
     * Скрывает лишние модификаторы, устанавливает кнопке новое количество скрытых модификаторов
     * @param {number} modifiersRowCount Количество модификаторов, помещающихся в один ряд вместе с кнопкой 'ещё'
     * @param {number} countOfHideModifiers Количество скрытых модификаторов
     */
    updateCountModifiers: function (modifiersRowCount, countOfHideModifiers) {
      var moreButton = this.$('.js-show-pic-modifiers > .link_pseudo');

      if (countOfHideModifiers > 1) {
        var visibleCount = modifiersRowCount + 1;
        this.$('.js-show-pic-modifiers').removeClass('not_display');
        moreButton.text('+ ' + countOfHideModifiers);
        this.$('.tab:nth-child(-n + ' + visibleCount + ')').removeClass('not_display');
        this.$('.tab:nth-child(n + ' + visibleCount + ')').addClass('not_display');
      } else {
        this.$('.js-show-pic-modifiers').addClass('not_display');
        this.$('.tab').removeClass('not_display');
      }
    },
  });
})(jQuery);

}.call(window));